import axios from 'axios';

export const getMaintenanceSetting = () => {
    return axios.get('/api/maintenance');
};